import { Injectable } from '@angular/core';
import { HttpService } from '../../core/services/http.service';

@Injectable({ providedIn: 'root' })
export class FlowsService {


  private listUrl = 'partners/flows/list';
  private getUrl = 'partners/flows/get';
  private getTermUrl = 'partners/flows/getTerm';
  private getSelectorTestUrl = 'partners/flows/getSelectorTest';
  private getFlowChartUrl = 'partners/flows/getFlowChart';
  private createFlowUrl = 'partners/flows/create';
  private saveFlowUrl = 'partners/flows/save';
  private getFilterAntifraudsUrl = 'partners/flows/getFilterAntifrauds';
  private getFilter3dsUrl = 'partners/flows/getFilter3ds';
  private publishFlowUrl = 'partners/flows/publish';
  private snapshotUrl = 'partners/flows/snapshot';
  private metricsUrl = 'partners/flows/metrics';
  private changeUrl = 'partners/flows/change';
  private compileUrl = 'partners/flows/compile';
  private publishSnapshotUrl = 'partners/flows/publish-snapshot';
  private timeMachineUrl = 'partners/flows/time-machine';
  private timeMachineMetricsUrl = 'partners/flows/time-machine-metrics';
  private createNewVersionUrl = 'partners/flows/create-new-version';
  private createTestABUrl = 'partners/flows/create-test-ab';
  private changeTestABUrl = 'partners/flows/change-test-ab';
  private finishTestABUrl = 'partners/flows/finish-test-ab';
  private resetUrl = 'partners/flows/reset';

  constructor(private httpService: HttpService) { }

  create(params, partner, account) {
    return this.httpService.post(this.createFlowUrl, params, partner, account, true);
  }

  list(partner: string, account: string, params) {
    return this.httpService.post(this.listUrl, params, partner, account, true);
  }

  snapshot(partner: string, account: string, params) {
    return this.httpService.post(this.snapshotUrl, params, partner, account);
  }

  getMetrics(partner, account, params) {
    return this.httpService.post(this.metricsUrl, params, partner, account, false);
  }

  getTimeMachineMetrics(partner, account, params) {
    return this.httpService.post(this.timeMachineMetricsUrl, params, partner, account, false);
  }

  getFlow(partner: string, account: string, snapshot_id, selector_test_id, flow_id, version, order, start, end, orders) {
    const params = {
      snapshot_id,
      selector_test_id,
      flow_id,
      version,
      order,
      start,
      end,
      orders
    };

    return this.httpService.post(this.getUrl, params, partner, account, true);
  }

  get(partner: string, account: string, selector_test_id, flow_id, version, order, start, end) {
    const params = {
      snapshot_id: 1,
      selector_test_id,
      flow_id,
      version,
      order,
      start,
      end
    };
    return this.httpService.post(this.getUrl, params, partner, account, true);
  }

  getSelectorTest(partner: string, account: string, selector_test_id, start, end) {
    const params = {
      selector_test_id,
      start_date: start,
      end_date: end
    };

    return this.httpService.post(this.getSelectorTestUrl, params, partner, account, true);
  }

  getTerm(partner: string, account: string, service_id) {
    const params = {
      service_id,
    };

    return this.httpService.post(this.getTermUrl, params, partner, account);
  }

  getFlowChart(partner: string, account: string, snapshot_id, selector_test_id, start, end, interval) {
    const params = {
      snapshot_id,
      selector_test_id,
      start_date: start,
      end_date: end,
      interval: interval
    };

    return this.httpService.post(this.getFlowChartUrl, params, partner, account);
  }

  getFilterAntifrauds(partner: string, account: string, loading = false) {
    return this.httpService.get(this.getFilterAntifraudsUrl, partner, account, loading);
  }

  getFilter3ds(partner: string, account: string, loading = false) {
    return this.httpService.get(this.getFilter3dsUrl, partner, account, loading);
  }

  save(partner: string, account: string, params, loading = true) {
    return this.httpService.post(this.saveFlowUrl, params, partner, account, loading);
  }

  publish(partner: string, account: string, params) {
    return this.httpService.post(this.publishFlowUrl, params, partner, account, true);
  }

  change(partner, account, params) {
    return this.httpService.post(this.changeUrl, params, partner, account, true);
  }

  compile(params, partner, account, loading = true) {
    return this.httpService.post(this.compileUrl, params, partner, account, loading);
  }

  publishSnapshot(params, partner, account) {
    return this.httpService.post(this.publishSnapshotUrl, params, partner, account, true);
  }

  getTimeMachine(partner, account) {
    return this.httpService.get(this.timeMachineUrl, partner, account);
  }

  createNewVersion(partner, account, params) {
    return this.httpService.post(this.createNewVersionUrl, params, partner, account, true);
  }

  createTestAB(partner, account, params) {
    return this.httpService.post(this.createTestABUrl, params, partner, account, true);
  }

  changeTestAB(partner, account, params) {
    return this.httpService.post(this.changeTestABUrl, params, partner, account, true);
  }

  finishTestAB(partner, account, params) {
    return this.httpService.post(this.finishTestABUrl, params, partner, account, true);
  }

  reset(partner, account, params) {
    return this.httpService.post(this.resetUrl, params, partner, account, true);
  }
}
